import { __decorate } from "tslib";
import C7nSkeleton from 'choerodon-ui/lib/skeleton';
import { observer } from 'mobx-react';
import React from 'react';
import omit from 'lodash/omit';
import { DataSetStatus } from '../data-set/enum';
import DataSetComponent from '../data-set/DataSetComponent';
import SkeletonButton from './Button';
import SkeletonInput from './Input';
import Avatar from './Avatar';
let Skeleton = class Skeleton extends DataSetComponent {
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'skeletonTitle',
        ]);
    }
    render() {
        const { dataSet, skeletonTitle, ...otherProps } = this.props;
        const props = {
            title: skeletonTitle,
        };
        const omitProps = omit(otherProps, 'title');
        if (dataSet) {
            props.loading = dataSet.status !== DataSetStatus.ready;
        }
        return React.createElement(C7nSkeleton, Object.assign({}, omitProps, props));
    }
};
Skeleton.displayName = 'Skeletions';
Skeleton.Button = SkeletonButton;
Skeleton.Input = SkeletonInput;
Skeleton.Avatar = Avatar;
Skeleton.defaultProps = {
    skeletonTitle: true,
};
Skeleton = __decorate([
    observer
], Skeleton);
export default Skeleton;
